import { Component, Inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialogClose,
  MatDialog,
  MatDialogRef,
  MatDialogModule,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { AppUrlConstants } from '../../../core/constants/AppUrlConstants';
import { AlertDialogComponent } from '../../../shared/alert-dialog/alert-dialog.component';
import { GenericCrudService } from '../../../core/services/generic-crud.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-complaint-type-add-edit-dialog',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule,
    ReactiveFormsModule, MatDialogClose, TranslateModule, MatCheckboxModule],
  templateUrl: './complaint-type-add-edit-dialog.component.html'
})
export class ComplaintTypeAddEditDialogComponent {
  form: FormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ComplaintTypeAddEditDialogComponent>,
    public dialog: MatDialog, private formBuilder: FormBuilder,
    private crudService: GenericCrudService, private authService: AuthenticationService) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      complaintCategoryId: [null],
      name: ['', [Validators.required, Validators.maxLength(60)]],
      description: ['', [Validators.required, Validators.maxLength(300)]],
      segmentId: [this.authService.getUserSegment()],
      isPublic: [false],
      whatsappNameEnglish: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(24)]],
      whatsappNameUrdu: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(24)]],
    });
    if (this.data != null) {
      this.form.patchValue({
        complaintCategoryId: this.data?.complaintCategoryId,
        name: this.data?.name,
        description: this.data?.description,
        segmentId: this.data?.segmentId,
        isPublic: this.data?.isPublic,
        whatsappNameEnglish: this.data?.whatsappNameEnglish,
        whatsappNameUrdu: this.data?.whatsappNameUrdu,
      })
    }
  }
  add() {
    this.crudService.add(this.form.value, AppUrlConstants.COMPLAINT_CATEGORY_URL + AppUrlConstants.ADD).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  edit() {
    this.crudService.edit(this.form.value, AppUrlConstants.COMPLAINT_CATEGORY_URL + AppUrlConstants.EDIT).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
}
